<template>
  <div v-if="organization" class="d-flex flex-column align-items-center">
    <personal-organization v-model="organization" style="width: 40em;"/>
    <btn-action class="btn btn-primary" @click="save">Сохранить</btn-action>
  </div>
</template>

<script>
  import PersonalOrganization from '../../components/personal/organization.vue'
  import BtnAction from '../../components/btn-action'
  import api from '@/api'

  export default {
    components: {
      BtnAction,
      PersonalOrganization,
    },
    props: ['id', 'organization_data'],
    data () {
      return {
      }
    },
    methods: {
      save () {
        return this.$validator.validateAll().then(success => {
          if (success) {
            if (this.id) {
              return api.put(`divisions/${this.id}`, this.organization)
            } else {
              return api.post(`divisions`, this.organization)
                .then(({data}) => {
                  this.$emit('organizationCreated', data)
                })
            }
          }
        })
      },
    },
    computed: {
      organization () {
        return this.organization_data
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/personal/organization.vue